<!-- Inverter Selector with Popover + Command -->
<div class="inverter-selector-container">
  <!-- Selected Inverters Display -->
  @if (selectedInvertersLocal().length > 0) {
  <div class="mb-3 flex flex-wrap gap-2 rounded-md border border-border p-3">
    <div class="flex flex-wrap gap-2">
      @for (inverterId of selectedInvertersLocal(); track inverterId) { @let
      inverter = getInverterById(inverterId); @if (inverter) {
      <div
        class="ks-chip"
      >
        <span>{{ inverter.name }} ({{ inverter.size }}kW)</span>
        <button
          type="button"
          class="hover:opacity-70 transition-opacity"
          (click)="removeInverter(inverterId, $event)"
        >
          <ng-icon name="lucideX" class="w-4 h-4"></ng-icon>
        </button>
      </div>
      } }
    </div>
  </div>
  }

  <!-- Popover Container -->
  <brn-popover
    #popover
    sideOffset="5"
  >
    <!-- Trigger Button -->
    <button
      class="ks-select-trigger"
      [disabled]="
        disabled() ||
        isLoading() ||
        selectedInvertersLocal().length >= maxInverters()
      "
      brnPopoverTrigger
    >
      <span class="truncate">
        @if (isLoading()) {
        <span class="flex items-center gap-2">
          <div
            class="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"
          ></div>
          Lädt...
        </span>
        } @else {
        <ng-icon name="lucidePlus" class="w-4 h-4 mr-1"></ng-icon>
        Wechselrichter hinzufügen }
      </span>
      <ng-icon name="lucideChevronDown" class="w-4 h-4"></ng-icon>
    </button>

    <!-- Command Content -->
    <div
      hlmPopoverContent
      class="ks-menu-panel w-full min-w-[400px] p-0"
      *brnPopoverContent="let ctx"
    >
      <hlm-command>
        <!-- Search -->
        <hlm-command-search>
          <ng-icon
            hlm
            name="lucideSearch"
            class="shrink-0 opacity-50"
          ></ng-icon>
          <input
            type="text"
            hlm-command-search-input
            placeholder="Wechselrichter suchen"
          />
        </hlm-command-search>

        <hlm-command-list>
          <!-- Error State -->
          @if (error()) {
          <p class="px-3 py-3 text-xs leading-normal text-destructive">{{ error() }}</p>
          }

          <!-- Inverters Section -->
          @if (!error()) { @if (inverters() && inverters().length > 0) {
          <!-- Inverters Group -->
          <hlm-command-group>
            <hlm-command-group-label
              >Verfügbare Wechselrichter ({{
                inverters().length
              }})</hlm-command-group-label
            >

            @for (inverter of inverters(); track inverter.id) {
            <button
              hlm-command-item
              [value]="getInverterSearchValue(inverter)"
              [style.background-color]="
                isInverterSelected(inverter.id) ? null : 'transparent'
              "
              [class.bg-accent]="isInverterSelected(inverter.id)"
              (click)="toggleInverter(inverter)"
              [disabled]="
                !isInverterSelected(inverter.id) &&
                selectedInvertersLocal().length >= maxInverters()
              "
            >
              <ng-icon hlm name="lucideZap" hlmCommandIcon></ng-icon>
              <div class="flex-1 text-left">
                <p class="text-sm font-normal truncate">
                  {{ inverter.name }}
                </p>
                <p class="text-xs text-muted-foreground truncate">
                  {{ inverter.size }} kW @if (inverter.efficiency) { •
                  {{ inverter.efficiency }}% } • {{ inverter.cost }} €
                </p>
              </div>
              @if (isInverterSelected(inverter.id)) {
              <ng-icon
                hlm
                name="lucideCheck"
                class="w-4 h-4 text-primary flex-shrink-0"
              ></ng-icon>
              }
            </button>
            }
          </hlm-command-group>
          } @else if (!isLoading()) {
          <!-- Empty state -->
          <div *brnCommandEmpty hlmCommandEmpty>
            Keine Wechselrichter vorhanden
          </div>
          } }
        </hlm-command-list>
      </hlm-command>
    </div>
  </brn-popover>
</div>
